







import { Component, Mixins, Prop, Emit } from "vue-property-decorator";

@Component({
})
export default class NotImplementedComponent extends Mixins() {
  @Prop({ default: () => "まだ実装されてません。" })
  overview: string;

  @Prop({ default: () => "まだ実装されてません。" })
  detail: string;

  @Emit()
  click(value: any): void {}
}
